<template>
	<div>
		<Modal 
		:loading="loading" 
		title="BAIXAR ROTEIRO"
		@close="close"
		@save="save">
			<div class="row">
				<div class="col-xs">
					<FormSelect v-model="selection" label="Selecione o tipo de arquivo" :options="getOptions()" icon="fa-file-download" :required="true" ref="selection" />
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
import Modal from "@/components/Modal";
import FormSelect from "@/components/FormSelect";

export default {
	name: "RoutingModalDownload",

	props: {
        current: {
            type: Object,
            require: true,
        },
        client_atak: {
            type: Number,
            require: false,
            default: 0,
        }
    },

	components: {
        Modal,
        FormSelect,
    },

	data: function() {
		return {
            loading: false,
            selection: "",
		}
	},

	methods: {
        getOptions: function() {
            return {
                0: "ARQUIVO PADRÃO (.CSV)",
                1: this.client_atak ? "ARQUIVO PADRÃO ATAK (.TXT)" : "ARQUIVO PADRÃO (.TXT)",
            };
        },

        // Retorna messagem de erro no campo determinado
        message: function(input) {
            return "'" + input + "' deve ser preenchido.";
        },

        // Verifica e valida inicialmente os campos
		validation: function() {
            let data = {
                selection: '',
            };
            let error = false;

            // Verifica o tipo selecionado
			if (this.selection == "") {
                this.$refs.selection.trigger_blur();
                this.$notification.error(this.message("TIPO DE EXPORTAÇÃO"));
                error = true;
			} else {
				data.selection = parseInt(this.selection);
            }
            
            // Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return data;
            }
        },

		// Envia para API e salva as informações no BD
        save: async function() {
            // Solicita a validação
			let form = this.validation();

            // Verifica o resultado da validação
			if(form == null) {
				return;
            }
            
            // Envia a seleção
            this.$emit("download", form.selection);
            this.close();
		},

		// Fecha o modal
		close: function() {
			this.$emit("close");
        },
	}
}
</script>

<style scoped>

</style>